export const identity = {
    yourIdentity: {
        revealIdentity: 'Varslers identitet',
        yesRevealIdentity: 'Ja, jeg vil avsløre identiteten min',
        noDontRevealIdentity: 'Nei, jeg vil forbli anonym',
    }
};
